module.exports = "<span ng-message=pattern> *Address street can contain only letters, numbers or common characters (\",\", \".\", \"-\", \"#\", \"/\") </span>";